import css from "../Form.module.css";
import { useRef, useEffect } from "react";
import FormLabel from "../FormLabel";

const Input = ({ children, onChange }) => {
  const { label, name, placeholder, type, value, required, disabled, infoImage } =
    children;
  const id = "id" + Date.now() + Math.random() * 1000;
  const internalRef = useRef();
  const ref = children.inputRef ?? internalRef;

  // keep input value in sync with props
  useEffect(() => {
    if (ref.current) {
      ref.current.value = value ?? "";
    }
  }, [value, children]);

  const setValue = (e) => {
    const newValue = e?.target?.value ?? ref.current.value;
    children.value = newValue;

    // always pass name + value to parent
    onChange?.({
      target: { name, value: newValue },
    });
  };

  return (
    <div className={css.FormControl}>
      <FormLabel
        id={id || name}
        label={label}
        required={required}
        infoImage={infoImage}
      />
      <div>
        <input
          disabled={disabled}
          id={id}
          required={!!required}
          defaultValue={value}
          onChange={setValue}
          ref={ref}
          type={type || "text"}
          name={name}
          placeholder={placeholder}
          autoComplete="off"
        />
      </div>
    </div>
  );
};

export default Input;
